<template>
  <detail-card section-key="Liquidity">
    <b-row>
      <b-col class="text-justify">
        <div v-if="score === null" class="text-center mb-3 mt-0">{{ $t('common.notAvailable') }}</div>
        <!-- One-way :value, not v-model like LiquidityValue.vue's own `v-model="value"` (a prop
        there) — score here is a computed with no setter, and the slider is read-only (disabled)
        regardless, so there's nothing to write back. -->
        <custom-slider
          :value="score"
          :min="0"
          :max="5"
          :disabled="true"
          tooltip="none"
          :dot-size="score !== null ? undefined : 0"
        ></custom-slider>
        <div class="d-flex mt-2">
          <div><span v-t="'productDetails.slider.illiquid'"></span></div>
          <div class="ml-auto"><span v-t="'productDetails.slider.liquid'"></span></div>
        </div>
      </b-col>
    </b-row>
  </detail-card>
</template>

<script>
// "Liquidabilità" (IBIPs-only Sidebar section). Backend-wise this is a plain field-catalog
// section (one Number field, LiquidabilityIndicatorScore) — DetailSection.vue dispatches it
// here instead of the generic FieldCatalogSection.vue because it renders a slider (LiquidityValue.vue
// style), not a label/value row: CustomSlider with a 0-5 range and illiquid/liquid captions,
// fed this section's single field. Card shell shared with FieldCatalogSection.vue via
// DetailCard.vue.
import CustomSlider from '../../Lib/CustomSlider.vue'
import DetailCard from '../DetailCard'

export default {
  name: 'liquidity-section',
  components: {
    CustomSlider,
    DetailCard,
  },
  props: {
    fields: { type: Array, required: true },
  },
  computed: {
    score() {
      const field = this.fields.find((f) => f.key === 'liquidabilityIndicatorScore')
      return field && field.value != null ? field.value : null
    },
  },
}
</script>
